module.exports = __webpack_public_path__ + "static/img/bundles__img-2.652eec13.svg";